// The vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import vue from 'vue'
import App from './App'
import router from './router'
import $ from 'jquery'
import './assets/scss/base.scss'
import './assets/scss/iconfont/iconfont.css'
import './assets/scss/swiper.min.css'
//Vant-ui
import './assets/scss/vant.css'
import vant from 'vant'

//移动端自适应
import './assets/plug-in/flexible.debug'
import './assets/plug-in/flexible_css.debug'
//axios
import axios from './assets/plug-in/http'
vue.prototype.HOST = '/api'
axios.defaults.withCredentials = true
vue.prototype.$axios = axios
vue.config.productionTip = false
import Promise from 'es6-promise'
Promise.polyfill()

//cookie
const cookie = require('vue-cookie')

//自定义公用模块
import utils from './assets/js/utils'

vue.prototype.utils = utils

import areaJson from './assets/plug-in/area.js'
vue.prototype.areaJson = areaJson

import veeValidate, {
	Validator
} from 'vee-validate'

import cn from 'vee-validate/dist/locale/zh_CN'
Validator.localize('cn', cn)

vue.use(require('vue-wechat-title')).use(wx).use(cookie).use(vant).use(veeValidate)
/* eslint-disable no-new */
new vue({
	el: '#app',
	router,
	components: {
		App
	},
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js